// extracted by mini-css-extract-plugin
export default {"button":"Button_button__cBa3c","navigation":"Button_navigation__CNYov"};